import { render, staticRenderFns } from "./activity3.vue?vue&type=template&id=2b845258&scoped=true"
import script from "./activity3.vue?vue&type=script&lang=js"
export * from "./activity3.vue?vue&type=script&lang=js"
import style0 from "./activity3.vue?vue&type=style&index=0&id=2b845258&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b845258",
  null
  
)

export default component.exports